<template>
    <div class="page-table tabStyle mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">Ürün Güncelle</div>
        <el-form status-icon :model="urunForm" :rules="rulesUrun" ref="urunForm" class="demo-ruleForm">
            <el-row :gutter="10">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <el-tabs tab-position="left" class="language">
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-tr"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.urun.tanimlama.baslik")'
                                                      prop="baslik">:
                                            <div v-if="linkVisible" style="float: right; display: flex">
                                                <div v-if="!VisibleA">
                                                    <el-link target="_blank" :underline="false"
                                                             href="https://www.kaderfood.ch/">
                                                        https://www.kaderfood.ch/{{this.urunForm.link}}
                                                    </el-link>
                                                </div>
                                                <el-button v-if="duzenleBtnVisible"
                                                           style="margin-left: 10px; margin-bottom: 5px"
                                                           v-on:click="VisibleA = true;  duzenleBtnVisible=false"
                                                           size="mini">Düzenle
                                                </el-button>
                                                <span v-if="VisibleA">https://www.kaderfood.ch/ </span>
                                                <el-input size="small" v-if="VisibleA" v-model="urunForm.link"
                                                          v-on:change="linkChange = false"
                                                          v-on:blur="linkTespitLink();VisibleA=false; duzenleBtnVisible=true"
                                                          style="width: 50%"></el-input>
                                            </div>
                                            <el-input size="small"
                                                      v-model="urunForm.baslik"
                                                      v-on:change="linkTespit"
                                                      :placeholder='$t("src.views.apps.urun.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik")'
                                                      prop="altBaslik">:
                                            <el-input size="small"
                                                      v-model="urunForm.altBaslik"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.urun.kategori.tanimlama.urunKodu")'
                                                prop="urunKodu">
                                            <el-input disabled size="small" v-model="urunForm.urunKodu"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                label='Fiyat'
                                                prop="fiyat">
                                            <el-input size="small" v-model="urunForm.fiyat">
                                                <template slot="append">CHF</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                label='Eski Fiyat'
                                                prop="eskiFiyat">
                                            <el-input size="small" v-model="urunForm.eskiFiyat">
                                                <template slot="append">CHF</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik")'
                                                      prop="icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      v-model="urunForm.icerik"
                                                      @input="seoIcerikTespit"
                                                      @blur="seoIcerikTespit"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim") + " (800x600)"'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik")'
                                                    prop="seoBaslik">:
                                                <el-input size="small"
                                                          v-model="urunForm.seoBaslik"
                                                          maxlength="60"
                                                          show-word-limit
                                                          :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik")'
                                                    prop="seoIcerik">:
                                                <el-input size="small" type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-de"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.urun.tanimlama.baslik") + "(Almanca)"'
                                                      prop="dil.de.baslik">:
                                            <el-input size="small"
                                                      v-model="urunForm.dil.de.baslik"
                                                      v-on:change="urunForm.dil.de.seoBaslik = urunForm.dil.de.baslik.substring(0, 60)"
                                                      :placeholder='$t("src.views.apps.urun.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik") + "(Almanca)"'
                                                      prop="dil.de.altBaslik">:
                                            <el-input size="small"
                                                      v-model="urunForm.dil.de.altBaslik"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.urun.kategori.tanimlama.urunKodu")'
                                                prop="urunKodu">
                                            <el-input disabled size="small" v-model="urunForm.urunKodu"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                label='Fiyat'
                                                prop="fiyat">
                                            <el-input size="small" v-model="urunForm.fiyat">
                                                <template slot="append">CHF</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                label='Eski Fiyat'
                                                prop="eskiFiyat">
                                            <el-input size="small" v-model="urunForm.eskiFiyat">
                                                <template slot="append">CHF</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik") + "(Almanca)"'
                                                      prop="dil.de.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      @input="seoIcerikDETespit"
                                                      @blur="seoIcerikDETespit"
                                                      v-model="urunForm.dil.de.icerik"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim") + " (800x600)"'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik") + "(Almanca)"'
                                                    prop="dil.de.seoBaslik">:
                                                <el-input size="small"
                                                          v-model="urunForm.dil.de.seoBaslik"
                                                          maxlength="60"
                                                          show-word-limit
                                                          :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik") + "(Almanca)"'
                                                    prop="dil.de.seoIcerik">:
                                                <el-input size="small" type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikDEChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.dil.de.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane>
                            <span slot="label"><i class="flag-icon flag-icon-gb"></i></span>
                            <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.urun.tanimlama.baslik") + "(İngilizce)"'
                                                      prop="dil.en.baslik">:
                                            <el-input size="small"
                                                      v-model="urunForm.dil.en.baslik"
                                                      v-on:change="urunForm.dil.en.seoBaslik = urunForm.dil.en.baslik.substring(0, 60)"
                                                      :placeholder='$t("src.views.apps.urun.tanimlama.baslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.altBaslik") + "(İngilizce)"'
                                                      prop="dil.en.altBaslik">:
                                            <el-input size="small"
                                                      v-model="urunForm.dil.en.altBaslik"
                                                      :placeholder='$t("src.views.apps.sayfa.tanimlama.altBaslikPlace")'></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                :label='$t("src.views.apps.urun.kategori.tanimlama.urunKodu")'
                                                prop="urunKodu">
                                            <el-input disabled size="small" v-model="urunForm.urunKodu"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                label='Fiyat'
                                                prop="fiyat">
                                            <el-input size="small" v-model="urunForm.fiyat">
                                                <template slot="append">CHF</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :lg="4" :md="4" :sm="24" :xs="24" class="col-p">
                                        <el-form-item
                                                label='Eski Fiyat'
                                                prop="eskiFiyat">
                                            <el-input size="small" v-model="urunForm.eskiFiyat">
                                                <template slot="append">CHF</template>
                                            </el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.icerik") + "(İngilizce)"'
                                                      prop="dil.en.icerik">:
                                            <ckeditor :editor="editor"
                                                      :config="editorConfig"
                                                      @input="seoIcerikENTespit"
                                                      @blur="seoIcerikENTespit"
                                                      v-model="urunForm.dil.en.icerik"></ckeditor>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                                <el-collapse-item title="Resim Ayarları" name="4">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item :label='$t("src.views.apps.sayfa.tanimlama.resim") + " (800x600)"'
                                                          prop="resim">:
                                                <el-upload
                                                        class="resimler"
                                                        action=""
                                                        list-type="picture-card"
                                                        multiple
                                                        :file-list="imageListMain"
                                                        :auto-upload="false"
                                                        accept=".jpg,.jpeg,.png"
                                                        :on-change="imageUpload"
                                                        :on-preview="firstImage"
                                                        :on-remove="imageRemove">
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </el-upload>
                                                <el-button style="margin-top: 15px;width: 150px;" type="primary"
                                                           v-on:click="serverImageList"
                                                           @click="dialogImgServerVisible = true; " size="mini">
                                                    Sunucudan
                                                    Seç
                                                </el-button>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                                <el-collapse-item title="SEO Ayarları" name="6">
                                    <el-row>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoBaslik") + "(İngilizce)"'
                                                    prop="dil.en.seoBaslik">:
                                                <el-input size="small"
                                                          v-model="urunForm.dil.en.seoBaslik"
                                                          maxlength="60"
                                                          show-word-limit
                                                          :placeholder='$t("src.views.apps.sayfa.tanimlama.seoBaslikPlace")'></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                            <el-form-item
                                                    :label='$t("src.views.apps.sayfa.tanimlama.seoIcerik") + "(İngilizce)"'
                                                    prop="dil.en.seoIcerik">:
                                                <el-input size="small" type="textarea"
                                                          maxlength="140"
                                                          v-on:focus="seoIcerikENChange = false"
                                                          show-word-limit
                                                          v-model="urunForm.dil.en.seoIcerik"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-collapse-item>
                            </el-collapse>
                        </el-tab-pane>
                    </el-tabs>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp delay-1s" v-model="activeCollapse">
                        <el-collapse-item name="1" :title='$t("src.views.apps.haberler.tanimlama.durum")'>
                            <el-row>
                                <el-button
                                        style="margin-bottom: 10px"
                                        size="mini" v-on:click="urunGuncelleme('urunForm')"
                                        class="onayBtn"
                                        type="primary">
                                    {{$t('src.views.apps.haberler.guncelleme.haberGuncelle')}}
                                </el-button>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item class="card-shadow--medium"
                                          title='* Kategori' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="kategoriList">
                                        <el-tree
                                                class="baskaTree"
                                                ref="kategori"
                                                :data="kategoriler"
                                                @check='handleNodeClick'
                                                node-key="id"
                                                icon-class
                                                show-checkbox
                                                :props="defaultProps">
                                        </el-tree>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item class="card-shadow--medium"
                                          title='* Malzemeler' name="2">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="malzemeList">
                                        <el-tree
                                                class="baskaTree"
                                                ref="malzeme"
                                                :data="malzemeListesi"
                                                :default-checked-keys="checkedKeysMalzeme"
                                                @check="handleNodeClickMal"
                                                node-key="umalzemeId"
                                                icon-class
                                                show-checkbox
                                                :props="defaultPropsMal">
                                        </el-tree>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <el-collapse-item class="card-shadow--medium"
                                          title='* Çıkarılacak Malzemeler' name="3">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item prop="cikarilacakMalzemeList">
                                        <el-tree
                                                class="baskaTree"
                                                ref="cikarilacakMalzeme"
                                                :data="cikarilacakMalzemeListesi"
                                                :default-checked-keys="checkedKeysCikarilacakMalzeme"
                                                @check="handleNodeClickCikarilacakMal"
                                                node-key="umalzemeId"
                                                icon-class
                                                show-checkbox
                                                :props="defaultPropsCikarilacakMal">
                                        </el-tree>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                        <!--<el-collapse-item class="card-shadow&#45;&#45;medium"-->
                        <!--title='Opsiyon' name="2">-->
                        <!--<el-row>-->
                        <!--<el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">-->
                        <!--<el-form-item prop="opsiyonList">-->
                        <!--<el-tree-->
                        <!--class="baskaTree"-->
                        <!--:data="opsiyonListesi"-->
                        <!--@check="handleNodeClickOps"-->
                        <!--:default-checked-keys="checkedKeysOpsiyon"-->
                        <!--ref="treeOps"-->
                        <!--check-strictly-->
                        <!--node-key="uopsiyonId"-->
                        <!--icon-class-->
                        <!--show-checkbox-->
                        <!--:props="defaultProps1">-->
                        <!--</el-tree>-->
                        <!--</el-form-item>-->
                        <!--</el-col>-->
                        <!--</el-row>-->
                        <!--</el-collapse-item>-->
                    </el-collapse>
                    <!--<div :lg="6" :md="6" :sm="24" :xs="24"-->
                    <!--v-for="(item,index) in secilenOpsiyonlar"-->
                    <!--:key="index">-->
                    <!--<el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">-->
                    <!--<el-collapse v-model="collapseOps">-->
                    <!--<el-collapse-item :title='item.label' :name="index"-->
                    <!--class="margin-top-10 card-shadow&#45;&#45;medium">-->
                    <!--<el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p"-->
                    <!--style="margin-top: 5px">-->
                    <!--<el-form-item :label='item.label'>:-->
                    <!--<el-input size="small"  v-model="item.aciklama"></el-input>-->
                    <!--</el-form-item>-->
                    <!--</el-col>-->
                    <!--<el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p"-->
                    <!--style="margin-top: 5px">-->
                    <!--<el-form-item :label='item.label + "(İngilizce)"'>:-->
                    <!--<el-input size="small"  v-model="item.aciklamaEN"></el-input>-->
                    <!--</el-form-item>-->
                    <!--</el-col>-->
                    <!--</el-collapse-item>-->
                    <!--</el-collapse>-->
                    <!--</el-collapse>-->
                    <!--</div>-->
                </el-col>
            </el-row>
        </el-form>
        <el-dialog
                title='Sunucudan Fotoğraf Seç'
                :visible.sync="dialogImgServerVisible"
                width="60%"
                center>
            <el-upload
                    action="#"
                    accept=".jpg,.jpeg,.png"
                    :on-change="serverImageUpload"
                    list-type="picture-card"
                    :file-list="imageListServer"
                    :auto-upload="false">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                    <span class="el-upload-list__item-actions">
                            <span class="el-upload-list__item-delete"
                                  @click="imageUploadtoServer(file)">
                                  <i class="el-icon-plus"></i>
                            </span>
                        </span>
                </div>
            </el-upload>
        </el-dialog>
    </div>
</template>

<script>
    import JQuery from 'jquery';
    import ClassicEditor from '../../../../node_modules/ckeditor5-build-classic';
    import urunService from '../../../WSProvider/UrunService'
    import seoService from '../../../WSProvider/SeoService'
    import controllerService from '../../../WSProvider/ControllerService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import EventBus from '@/components/event-bus'

    let $ = JQuery;
    export default {
        name: "UrunDuzenle",
        components: {},
        mounted() {

            this.getKategoriList();
            // this.getOpsiyonList();
            this.updateUrunId = this.$store.getters.getUpdateKodu;
            this.updateUrunLink = this.$store.getters.getUpdateLink;
            this.getUrunDetay();
        },
        data() {
            return {
                malzemeVis: false,
                malzemeListesi: [],
                cikarilacakMalzemeListesi: [],
                checkedKeysKategori: [],
                checkedKeysOpsiyon: [],
                checkedKeysMalzeme: [],
                checkedKeysCikarilacakMalzeme: [],
                defaultProps: {
                    id: 'ukategoriId',
                    children: 'children',
                    label: 'name'
                },
                defaultPropsMal: {
                    umalzemeId: 'umalzemeId',
                    label: 'baslik'
                },
                defaultPropsCikarilacakMal: {
                    umalzemeId: 'umalzemeId',
                    label: 'baslik'
                },
                defaultProps1: {
                    uopsiyonId: 'uopsiyonId',
                    label: 'baslik'
                },
                opsiyonAciklamaForm: {
                    opsiyonBaslik: [],
                    opsiyonBaslikDE: [],
                },
                path: urunService.path,
                dialogKonum: false,
                opsiyonDetayVisible: false,
                konumText: "Seç",
                limit: 0,
                updateUrunId: '',
                updateUrunLink: '',
                updateData: [],
                updateDataDE: [],
                updateDataEN: [],
                urunDetayKlon: [],
                imageListServer: [],
                fileListServer: [],
                dialogImgServerVisible: false,
                dialogDocServerVisible: false,
                seoIcerikChange: true,
                seoIcerikDEChange: true,
                seoIcerikENChange: true,
                VisibleA: false,
                linkChange: true,
                linkVisible: false,
                duzenleBtnVisible: true,
                imageListMain: [],
                oldOpsiyonList: [],
                oldKategoriList: [],
                oldMalzemeList: [],
                oldAlanList: [],
                oldCikarilacakMalzemeList: [],
                ozelAlanListesi: [],
                updateDataOps: [],
                updateDataKat: [],
                updateDataMal: [],
                updateDataCikarilacakMal: [],
                updateAlanList: [],
                orjinalResimList: [],
                fileListMain: [],
                kategoriler: [],
                opsiyonListesi: [],
                secilenOpsiyonlar: [],
                secilenlerKlon: [],
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7'],
                collapseOps: ['1'],
                visibleSil: false,
                urunForm: {
                    baslik: "",
                    altBaslik: "",
                    birim: "",
                    icerik: "",
                    link: '',
                    urunKodu: '',
                    seoBaslik: '',
                    seoIcerik: '',
                    fiyat: '',
                    eskiFiyat: '',
                    resim: [],
                    kategoriListesi: [],
                    opsiyon: [],
                    malzemeListesi: [],
                    cikarilacakMalzemeListesi: [],
                    alanList: [],
                    durum: "1",
                    dil: {
                        de: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        },
                        en: {
                            baslik: '',
                            altBaslik: '',
                            icerik: '',
                            seoBaslik: '',
                            seoIcerik: ''
                        },

                    },
                },
                rulesUrun: {
                    baslik: [{
                        required: true,
                        message: " ",
                        trigger: 'change'
                    }],
                    ustKategori: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                    urunKodu: [{
                        required: true,
                        message: " ",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            getKategoriList() {
                urunService.kategoriTree().then((response) => {
                    if (response.status === 200) {
                        this.kategoriler = response.data;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            getOpsiyonList() {
                urunService.uopsiyonList(1, '', '').then((response) => {
                    if (response.status === 200) {
                        this.opsiyonListesi = response.data;
                    } else {
                        notification.Status(response.status, this);
                    }
                })
            },
            handleNodeClick(data, checked, indeterminate) {
                if(checked.checkedNodes.length > 0){
                    let self = this;
                    this.urunForm.kategoriListesi = [];
                    if (!data.children || !data.children.length) {
                        if (checked.checkedNodes.length > 0) {
                            this.$refs.kategori.setCheckedKeys([data.id])
                            this.urunForm.kategoriListesi.push(data.id)
                        }
                    } else {
                        this.$refs.kategori.setCheckedKeys([])
                    }
                    this.getukategoriMalzemeList();
                }
                else{
                    this.urunForm.malzemeListesi = []
                }
            },
            handleNodeClickMal(data, checked, indeterminate) {
                this.urunForm.malzemeListesi = checked.checkedNodes;
            },
            handleNodeClickCikarilacakMal(data, checked, indeterminate) {
                this.urunForm.cikarilacakMalzemeListesi = checked.checkedNodes;
            },
            getukategoriMalzemeList() {
                urunService.ukategoriMalzemeList(this.urunForm.kategoriListesi[0]).then((response) => {
                    if (response.status === 200) {
                        this.malzemeListesi = response.data;
                        this.cikarilacakMalzemeListesi = response.data;
                        this.malzemeVis = true;
                        console.log("malzeme listesi Response data : ", response.data)
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            // handleNodeClickOps(data, checked) {
            //     let self = this;
            //     if (checked.checkedKeys.length > 0) {
            //         let obj = checked.checkedNodes.find(dizi => dizi.uopsiyonId === data.uopsiyonId);
            //         if (obj !== undefined) {
            //             this.secilenOpsiyonlar.push({
            //                 uopsiyonId: data.uopsiyonId,
            //                 label: data.baslik,
            //             });
            //         } else {
            //             this.secilenOpsiyonlar.forEach(function (e, i) {
            //                 if (e.uopsiyonId === data.uopsiyonId) {
            //                     self.secilenOpsiyonlar.splice(i, 1);
            //                 }
            //             });
            //         }
            //     } else self.secilenOpsiyonlar = []
            // },
            linkTespitLink() {
                let self = this;
                if (this.urunForm.link) {
                    seoService.linkKontrol(self.urunForm.link.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            self.urunForm.link = response.data;
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            linkTespit() {
                let self = this;
                if (this.linkChange) {
                    seoService.linkKontrol(self.urunForm.baslik.replace("'", "")).then((response) => {
                        if (response.status === 200) {
                            if (self.urunForm.baslik) {
                                self.urunForm.seoBaslik = self.urunForm.baslik.substring(0, 60);
                                if (response.status === 200) {
                                    self.linkVisible = true;
                                    self.urunForm.link = response.data;
                                }
                            } else if (!self.urunForm.baslik) {
                                self.linkVisible = false;
                                self.urunForm.link = '';
                                self.urunForm.seoBaslik = '';
                            }
                        } else {
                            notification.Status(response.status, this)
                        }
                    })
                }
            },
            getUrunDetay() {
                let self = this;
                urunService.urunDetay(this.updateUrunId).then((response) => {
                    if (response.status === 200) {
                        // console.log("urun detay gelen veri =>>>>>>>>>>>>>>>>>>", response.data)
                        if (response.data.anaResim) {
                            self.orjinalResimList.push(response.data.anaResim);
                            self.imageListMain.push({
                                name: response.data.anaResim,
                                url: urunService.imageUrlOrta + response.data.anaResim
                            });
                        }
                        if (response.data['resim']) {
                            response.data['resim'].forEach(function (e) {
                                if (e) {
                                    self.orjinalResimList.push(e);
                                    self.imageListMain.push({
                                        name: e,
                                        url: urunService.imageUrlOrta + e
                                    });
                                }
                            });
                        }
                        if (response.data.kategori.length > 0) {
                            self.oldKategoriList = response.data.kategori;
                            response.data.kategori.forEach(function (e) {
                                self.urunForm.kategoriListesi.push(e.ukategoriId);
                                self.checkedKeysKategori.push(e.ukategoriId)
                            });
                            self.$refs.kategori.setCheckedKeys(self.checkedKeysKategori);
                            self.getukategoriMalzemeList();
                        }
                        if (response.data.malzeme.length > 0) {
                            self.oldMalzemeList = response.data.malzeme;
                            response.data.malzeme.forEach(function (e) {
                                self.urunForm.malzemeListesi.push(e);
                                self.checkedKeysMalzeme.push(e.umalzemeId)
                            });

                            self.$refs.malzeme.setCheckedKeys(self.checkedKeysMalzeme);
                        }
                        if (response.data.malzemeCikarilacak.length > 0) {
                            self.oldCikarilacakMalzemeList = response.data.malzemeCikarilacak;
                            response.data.malzemeCikarilacak.forEach(function (e) {
                                self.urunForm.cikarilacakMalzemeListesi.push(e);
                                self.checkedKeysCikarilacakMalzeme.push(e.umalzemeId)
                            });

                            self.$refs.cikarilacakMalzeme.setCheckedKeys(self.checkedKeysCikarilacakMalzeme);
                        }
                        // if (response.data.opsiyon) {
                        //     this.oldOpsiyonList = response.data.opsiyon;
                        //     response.data.opsiyon.forEach(function (e) {
                        //         self.urunForm.opsiyon.push(e.uopsiyonId)
                        //         self.checkedKeysOpsiyon.push(e.uopsiyonId)
                        //         self.secilenOpsiyonlar.push({
                        //             uopsiyonId: e.uopsiyonId,
                        //             label: e.baslik,
                        //             aciklama: e.aciklama,
                        //             aciklamaEN: e.dil.en.aciklama,
                        //         });
                        //     });
                        //     self.secilenlerKlon = JSON.stringify(self.secilenOpsiyonlar);
                        //     this.$nextTick(() => {
                        //         this.$refs.treeOps.setCheckedKeys(self.checkedKeysOpsiyon);
                        //     });
                        //
                        // }
                        if (response.data.icerik) {
                            this.urunForm.icerik = htmlDecode(response.data.icerik);
                        }
                        if (response.data.link) {
                            this.urunForm.link = response.data.link;
                            this.linkVisible = true
                        }

                        self.urunForm.baslik = response.data.baslik;
                        self.urunForm.altBaslik = response.data.altBaslik;
                        self.urunForm.birim = response.data.birim;
                        self.urunForm.urunKodu = response.data.urunKodu;
                        self.urunForm.webSite = response.data.webSite;
                        self.urunForm.seoBaslik = response.data.seoBaslik;
                        self.urunForm.seoIcerik = response.data.seoIcerik;
                        self.urunForm.fiyat = response.data.fiyat;
                        self.urunForm.eskiFiyat = response.data.eskiFiyat;
                        if (response.data.dil.de) {
                            self.urunForm.dil.de.baslik = response.data.dil.de.baslik;
                            self.urunForm.dil.de.altBaslik = response.data.dil.de.altBaslik;
                            self.urunForm.dil.de.seoBaslik = response.data.dil.de.seoBaslik;
                            self.urunForm.dil.de.seoIcerik = response.data.dil.de.seoIcerik;
                            if (response.data.dil.de.icerik) {
                                self.urunForm.dil.de.icerik = functions.htmlDecode(response.data.dil.de.icerik);
                            }
                        }
                        if (response.data.dil.en) {
                            self.urunForm.dil.en.baslik = response.data.dil.en.baslik;
                            self.urunForm.dil.en.altBaslik = response.data.dil.en.altBaslik;
                            self.urunForm.dil.en.seoBaslik = response.data.dil.en.seoBaslik;
                            self.urunForm.dil.en.seoIcerik = response.data.dil.en.seoIcerik;
                            if (response.data.dil.en.icerik) {
                                self.urunForm.dil.en.icerik = functions.htmlDecode(response.data.dil.en.icerik);
                            }
                        }
                        self.urunDetayKlon = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },



            seoIcerikTespit() {
                if (this.seoIcerikChange) {
                    const myStr = functions.strip_html_tags(this.urunForm.icerik);
                    this.urunForm.seoIcerik = myStr.substring(0, 140);
                }
            },
            seoIcerikDETespit() {
                if (this.seoIcerikDEChange && this.urunForm.dil.de.icerik) {
                    const myStr = functions.strip_html_tags(this.urunForm.dil.de.icerik);
                    this.urunForm.dil.de.seoIcerik = myStr.substring(0, 140);
                } else this.urunForm.dil.de.seoIcerik = '';
            },
            seoIcerikENTespit() {
                if (this.seoIcerikENChange && this.urunForm.dil.en.icerik) {
                    const myStr = functions.strip_html_tags(this.urunForm.dil.en.icerik);
                    this.urunForm.dil.en.seoIcerik = myStr.substring(0, 140);
                } else this.urunForm.dil.en.seoIcerik = '';
            },
            firstImage(item) {
                var index = this.imageListMain.indexOf(item);
                this.imageListMain.splice(index, 1);
                this.imageListMain.unshift(item);
                notification.Status('success', this, item.name + " ana resim olarak ayarlandı..");
            },
            serverImageUpload(file, fileList) {
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    this.sumResimFonk(file, randomText(13) + '-' + file.name);
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            serverImageList() {
                var dizi = [];
                controllerService.sunucuResim('urun').then((response) => {
                    if (response.status === 200) {
                        response.data.forEach(function (e) {
                            var item = {
                                name: e,
                                url: urunService.imageUrlOrta + e
                            };
                            dizi.push(item);
                        });
                        this.imageListServer = dizi;
                    }
                })
            },
            imageUploadtoServer(file) {
                if (this.imageListMain.length === 0) {
                    var item = {
                        name: file.name,
                        url: file.url,
                    };
                    this.imageListMain.push(item);
                    updateList(this, 'resim', 1, file.name);
                    notification.Status('success', this, file.name + ' resmi eklendi.');
                } else {
                    let obj = this.imageListMain.find(data => data.name === file.name);
                    if (obj === undefined) {
                        item = {
                            name: file.name,
                            url: file.url,
                        };
                        this.imageListMain.push(item);
                        updateList(this, 'resim', 1, file.name);
                        notification.Status('success', this, file.name + ' resmi eklendi.');
                    } else {
                        notification.Status('warning', this, 'Bu resim zaten mevcut');
                    }
                }
            },
            imageRemove(file) {
                this.imageListMain.splice(this.imageListMain.indexOf(file), 1);
                updateList(this, 'resim', 0, file.name);
            },
            sumResimFonk(file, imgname) {
                const files = file.raw;
                if (files) {
                    const reader = new FileReader();
                    reader.onload = e => {
                        const data = e.target.result;
                        controllerService.resimYukle('urun', imgname, data).then((response) => {
                            if (response.status === 200) {

                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    };
                    reader.readAsDataURL(files);
                }
            },
            imageUpload(file, fileList) {
                fileList.pop();
                if (file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    var tip = file.raw["type"].split("/")[1];
                    if (this.urunForm.baslik) {
                        var imgname = randomText(13) + '-' + this.urunForm.link + "." + tip;
                    } else {
                        imgname = randomText(13) + '-' + file.name;
                    }
                    if (this.imageListMain.length === 0) {
                        var item = {
                            name: imgname,
                            url: file.url,
                            id: file.raw.lastModified
                        };
                        this.imageListMain.push(item);
                        this.sumResimFonk(file, imgname);
                        updateList(this, 'resim', 1, imgname);
                    } else {
                        let obj = this.imageListMain.find(data => data.id === file.raw.lastModified);
                        if (obj === undefined) {
                            item = {
                                name: imgname,
                                url: file.url,
                                id: file.raw.lastModified
                            };
                            this.imageListMain.push(item);
                            this.sumResimFonk(file, imgname);
                            updateList(this, 'resim', 1, imgname);
                        } else {
                            notification.Status('warning', this, 'Bu resim zaten mevcut');
                        }
                    }
                } else {
                    fileList.pop();
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.visibleSil = false;
                this.imageListMain = [];
                this.fileListMain = [];
                this.linkVisible = false;
                let tabs = this.$store.getters.getTabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "urunDuzenle");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "urunDuzenle") {
                            this.$store.getters.getTabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },
            urunGuncelleme(formName) {
                let self = this;
                var klonDizi = [];
                for (var key in this.urunDetayKlon) {
                    if (key !== 'resim' && key !== 'belge' && key !== 'opsiyon' && key !== 'kategori' && key !== 'malzeme' && key !== 'dil' && key !== 'malzemeCikarilacak') {
                        //if (this.urunDetayKlon[key] !== this.urunForm[key]) {
                            if (this.urunForm[key] || this.urunForm[key] === '') {
                                var item = {
                                    type: key,
                                    value: this.urunForm[key]
                                };
                                this.updateData.push(item);
                            }
                        //}
                    } else if (key === "resim") {
                        if (self.imageListMain.length === 0) {
                            if (self.orjinalResimList.length > 0) {
                                self.orjinalResimList.forEach(function (e) {
                                    updateList(self, 'resim', 0, e);
                                })
                            }
                        } else {
                            for (var k = 0; k < self.imageListMain.length; k++) {
                                if (k === 0) {
                                    if (self.imageListMain[0].name !== self.orjinalResimList[0]) {
                                        updateList(self, 'resim', 2, self.imageListMain[0].name);
                                        let obj = self.imageListMain.find(data => data.name === self.orjinalResimList[0]);
                                        if (obj !== undefined) {
                                            updateList(self, 'resim', 1, self.orjinalResimList[0]);
                                        }
                                    }
                                } else {
                                    let obj = self.orjinalResimList.find(data => data === self.imageListMain[k].name);
                                    if (obj === undefined) {
                                        updateList(self, 'resim', 1, self.imageListMain[k].name);
                                    }
                                }
                            }
                            if (self.orjinalResimList.length > 0) {
                                for (var y = 1; y < self.orjinalResimList.length; y++) {
                                    let obj = self.imageListMain.find(data => data.name === self.orjinalResimList[y]);
                                    if (obj === undefined) {
                                        updateList(self, 'resim', 0, self.orjinalResimList[y]);
                                    }
                                }
                            }
                        }
                    } else if (key === 'opsiyon') {
                        for (var i = 0; i < self.secilenOpsiyonlar.length; i++) {
                            let obj1 = self.oldOpsiyonList.find(data => data.uopsiyonId === self.secilenOpsiyonlar[i].uopsiyonId);
                            if (obj1 === undefined) {
                                self.updateDataOps.push({
                                    durum: 1,
                                    uopsiyonId: self.secilenOpsiyonlar[i].uopsiyonId,
                                    aciklama: self.secilenOpsiyonlar[i].aciklama,
                                    dil: {
                                        de: self.secilenOpsiyonlar[i].aciklamaDE,
                                    }
                                });

                            }
                            if (self.secilenlerKlon.length !== 0) {
                                let obj2 = JSON.parse(self.secilenlerKlon).find(data => data.uopsiyonId === self.secilenOpsiyonlar[i].uopsiyonId);
                                klonDizi.push(obj2);
                                if (obj2) {
                                    if (self.secilenOpsiyonlar[i].aciklama !== klonDizi[i].aciklama) {
                                        self.updateDataOps.push({
                                            durum: 2,
                                            uopsiyonId: self.secilenOpsiyonlar[i].uopsiyonId,
                                            aciklama: self.secilenOpsiyonlar[i].aciklama,
                                            dil: {
                                                de: self.secilenOpsiyonlar[i].aciklamaDE,
                                            }
                                        })
                                    }
                                }
                            }
                        }
                        for (var j = 0; j < this.oldOpsiyonList.length; j++) {
                            let obj0 = self.secilenOpsiyonlar.find(data => data.uopsiyonId === self.oldOpsiyonList[j].uopsiyonId);
                            if (obj0 === undefined) {
                                self.updateDataOps.push({
                                    durum: 0,
                                    uopsiyonId: self.oldOpsiyonList[j].uopsiyonId,
                                })
                            }
                        }
                    } else if (key === 'kategori') {
                        for (var ii = 0; ii < self.urunForm.kategoriListesi.length; ii++) {
                            let obj11 = self.oldKategoriList.find(data => data.ukategoriId === self.urunForm.kategoriListesi[ii]);
                            if (obj11 === undefined) {
                                self.updateDataKat.push({
                                    durum: 1,
                                    ukategoriId: self.urunForm.kategoriListesi[ii],
                                });
                            }
                        }
                        for (var jj = 0; jj < this.oldKategoriList.length; jj++) {
                            let obj00 = self.urunForm.kategoriListesi.find(data => data === self.oldKategoriList[jj].ukategoriId);
                            if (obj00 === undefined) {
                                self.updateDataKat.push({
                                    durum: 0,
                                    ukategoriId: self.oldKategoriList[jj].ukategoriId,
                                })
                            }
                        }
                    } else if (key === 'malzeme') {
                        for (var iii = 0; iii < self.urunForm.malzemeListesi.length; iii++) {
                            let obj111 = self.oldMalzemeList.find(data => data.umalzemeId === self.urunForm.malzemeListesi[iii].umalzemeId);
                            if (obj111 === undefined) {
                                self.updateDataMal.push({
                                    durum: 1,
                                    umalzemeId: self.urunForm.malzemeListesi[iii].umalzemeId,
                                });
                            }
                        }
                        for (var jjj = 0; jjj < this.oldMalzemeList.length; jjj++) {
                            let obj000 = self.urunForm.malzemeListesi.find(data => data.umalzemeId === self.oldMalzemeList[jjj].umalzemeId);
                            if (obj000 === undefined) {
                                self.updateDataMal.push({
                                    durum: 0,
                                    umalzemeId: self.oldMalzemeList[jjj].umalzemeId,
                                })
                            }
                        }
                    } else if (key === 'malzemeCikarilacak'){
                        for (var iii = 0; iii < self.urunForm.cikarilacakMalzemeListesi.length; iii++) {
                            let obj111 = self.oldCikarilacakMalzemeList.find(data => data.umalzemeId === self.urunForm.cikarilacakMalzemeListesi[iii].umalzemeId);
                            if (obj111 === undefined) {
                                self.updateDataCikarilacakMal.push({
                                    durum: 2,
                                    umalzemeId: self.urunForm.cikarilacakMalzemeListesi[iii].umalzemeId,
                                });
                                // self.updateDataMal.push({
                                //     durum: 2,
                                //     umalzemeId: self.urunForm.cikarilacakMalzemeListesi[iii].umalzemeId,
                                // });
                            }
                        }
                        for (var jjj = 0; jjj < this.oldCikarilacakMalzemeList.length; jjj++) {
                            let obj000 = self.urunForm.cikarilacakMalzemeListesi.find(data => data.umalzemeId === self.oldCikarilacakMalzemeList[jjj].umalzemeId);
                            if (obj000 === undefined) {
                                self.updateDataCikarilacakMal.push({
                                    durum: 3,
                                    umalzemeId: self.oldCikarilacakMalzemeList[jjj].umalzemeId,
                                })
                                // self.updateDataMal.push({
                                //     durum: 3,
                                //     umalzemeId: self.oldCikarilacakMalzemeList[jjj].umalzemeId,
                                // })
                            }
                        }
                    } else if (key === 'dil') {
                        for (var keyDil in this.urunDetayKlon.dil.de) {
                            if (this.urunDetayKlon.dil.de[keyDil] !== this.urunForm.dil.de[keyDil]) {
                                if (this.urunForm.dil.de[keyDil] || this.urunForm.dil.de[keyDil] === '') {
                                    var itemDe = {
                                        type: keyDil,
                                        value: this.urunForm.dil.de[keyDil]
                                    };
                                    this.updateDataDE.push(itemDe);
                                }
                            }
                        }
                        for (var keyDil2 in this.urunDetayKlon.dil.en) {
                            if (this.urunDetayKlon.dil.en[keyDil2] !== this.urunForm.dil.en[keyDil2]) {
                                if (this.urunForm.dil.en[keyDil2] || this.urunForm.dil.en[keyDil2] === '') {
                                    var itemEn = {
                                        type: keyDil2,
                                        value: this.urunForm.dil.en[keyDil2]
                                    };
                                    this.updateDataEN.push(itemEn);
                                }
                            }
                        }
                        if (this.updateDataDE.length !== 0 || this.updateDataEN.length !== 0) {
                            this.updateData.push({
                                type: "dil",
                                value: {
                                    de: this.updateDataDE,
                                    en: this.updateDataEN,
                                }
                            })
                        }
                    }

                }
                var statusKat = false;
                var statusOps = false;
                var statusAlan = false;
                var statusMal = false;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (self.updateDataOps.length !== 0) {
                            urunService.urunOpsiyonGuncelle(self.updateUrunId, self.updateDataOps).then((response) => {
                                if (response.status === 200) {
                                    statusOps = true;
                                    notification.Status('success', self, 'Opsiyon başarıyla güncellendi.');
                                    this.resetForm(formName);
                                    EventBus.$emit("urunList", true)

                                } else {
                                    notification.Status(response.status, self);
                                }
                            })
                        } else {
                            statusOps = true;
                        }
                        if (self.updateDataKat.length !== 0) {
                            urunService.urunKategoriGuncelle(self.updateUrunId, self.updateDataKat).then((response) => {
                                if (response.status === 200) {
                                    statusKat = true;
                                    notification.Status('success', self, 'Kategori başarıyla güncellendi.');
                                    self.resetForm(formName);
                                    EventBus.$emit("urunList", true)

                                } else {
                                    notification.Status(response.status, self);
                                }
                            })
                        } else {
                            statusKat = true;
                        }
                        if (self.updateDataMal.length !== 0) {
                            urunService.urunMalzemeGuncelle(self.updateUrunId, self.updateDataMal).then((response) => {
                                if (response.status === 200) {
                                    statusMal = true;
                                    notification.Status('success', self, 'Malzeme başarıyla güncellendi.');
                                    this.resetForm(formName);
                                    EventBus.$emit("urunList", true)

                                } else {
                                    notification.Status(response.status, self);
                                }
                            })
                        } else {
                            statusMal = true;

                        }
                        if (self.updateDataCikarilacakMal.length !== 0) {
                            urunService.urunCikarilacakMalzemeGuncelle(self.updateUrunId, self.updateDataCikarilacakMal).then((response) => {
                                if (response.status === 200) {
                                    statusMal = true;
                                    notification.Status('success', self, 'Çıkarılacak malzemeler başarıyla güncellendi.');
                                    this.resetForm(formName);
                                    EventBus.$emit("urunList", true)

                                } else {
                                    notification.Status(response.status, self);
                                }
                            })
                        } else {
                            statusMal = true;

                        }

                        if (self.updateData.length !== 0) {
                            urunService.urunGuncelle(this.updateUrunId, this.updateData).then((response) => {
                                //console.log("Urun güncelleme urun data : ", this.updateData)
                                if (response.status === 200) {
                                    // if (statusKat && statusMal && statusOps && statusAlan) {
                                    //console.log("update urun :", response.data)
                                    notification.Status('success', self, 'Ürün başarıyla güncellendi.');
                                    self.resetForm(formName);
                                    EventBus.$emit("urunList", true)
                                    // }
                                } else if (response.status === 230) {
                                    notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir haber zaten mevcut');
                                } else {
                                    notification.Status(response.status, this)
                                }
                            });
                        }
                    } else
                        notification.Status('warning', this, 'Değişiklik yapılmadı!');
                })
            },
            changeKonum(konum) {
                this.dialogKonum = false;
                this.konumText = "Değiştir";
                switch (konum) {
                    case '0' :
                        notification.Status('success', this, 'Opsiyon konumu "Tab" olarak seçildi.');
                        break;
                    case '1' :
                        notification.Status('success', this, 'Opsiyon konumu "Sağ" olarak seçildi.');
                        break;
                }
            }
        }
    }

    function htmlDecode(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }

    function updateList(self, type, durum, name) {
        var item = {
            type: type,
            value: [{
                durum: durum,
                [type]: name
            }]
        };
        self.updateData.push(item);
    }


    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return bugun + "-" + text;
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables';

    #transfer1 {
        display: flex;
    }

    #transfer2 {
        display: flex;
        position: relative;
        left: 25px;
    }

    .aciklamaSpan {
        position: absolute;
        top: 25px;
    }

    .page-table {
        &.overflow {
            overflow: hidden;
        }

        .table-box {
            overflow: hidden;
        }
    }

    .el-form-item {
        font-weight: bold;
    }

</style>
